import { RootState } from "../../../store";
import { useDispatch, useSelector } from "react-redux";
import { selectStore } from "../../../store/selector";
import { Button, Card, Col, DatePicker, Form, Input, InputNumber, message, Modal, Row, Select, Table, TimePicker } from "antd";
import dayjs from "dayjs";
import locale from "antd/es/date-picker/locale/ru_RU";
import { InnerTabs, MyBreadcrumb, MyButton, MyModalForm, MyText, OuterTabs } from "../../../components";
import { EditOutlined, EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { generatePath, useNavigate, useSearchParams } from "react-router-dom";
import { ModalBodyInline, ModalBodyItem, ModalBodyItemLeft, ModalBodyItemText, ModalTitle } from "./index.style";
import TextArea from "antd/lib/input/TextArea";
import { deletePsychologistSchedule, deletePsychologistWork, getPsychologistSchedule, getPsychologistTeachers, getPsychologistWork, getPsychologistWorkFilter, getPsychologistWorkGroup, getPsychologistWorkGroupStudents, postPsychologistSchedule, postPsychologistScheduleReset, postPsychologistWork, putPsychologistSchedule, putPsychologistScheduleReset, putPsychologistWork } from "../../../store/pages/psychologist/actions";
import { SCHEDULE_WEEKS } from "../../../constants/main";
import { DATE_FORMAT, QUERY_PARAMS, ROUTE_PATH } from "../../../constants";
import { STUDENT } from './../../../store/constants';


const rules = [
  {
    required: true,
    message: 'Введите!',
  },
]

const GROUP = "Групповые занятия";
const WORK_PARENT = "Работа с родителями"
const WORK_TEACHER = "Работа с педагогами"
const WORK_STUDENT = "Работа со студентами"

const FORM = {
  ID: "id",
  TYPE: 'type',
  START_TIME: "start_time",
  END_TIME: "end_time",
  BREAK_START_TIME: "break_start_time",
  BREAK_END_TIME: "break_end_time",
  NOTE: "note",
  WEEKDAYS: "weekdays",
  DATE: "date_at",
  THEME: "theme",
  GROUP_ID: "group_id",
  ATTENDEES_COUNT: "attendees_count",
  STUDENT: "person_id",
  REASON_TYPE: "reason_type",
  PERIODICITY: "periodicity",
  DURATION: "duration",
  REASON_TEXT: "reason_text",
  GROUP: "group",
  PARENT: "parent_type",
  TEACHER: "person_id",
  TEACHER_FORM: "teacher",
  ACTION: 'action'
}

interface IWorkSubtab {
  selectedType: string,
  searchParams: any,
  setSearchParams: any
}
export const WorkSubtabView = ({ selectedType, searchParams, setSearchParams }: IWorkSubtab) => {
  const { t } = useTranslation("common")
  const dispatch = useDispatch();
  const typeQuery = searchParams.get(QUERY_PARAMS.subtitle);
  const typeQuerySubInner = searchParams.get(QUERY_PARAMS.subInner);
  const navigate = useNavigate();
  const {
    psychologist: {
      psychologistWorkFilter,
      psychologistWork,
      psychologistWorkGroups,
      psychologistWorkGroupsStudents,
      postPsychologistWork: postPsychologistWorkData,
      editPsychologistWork,
      deletePsychologistWork: deletePsychologistWorkData,
      psychologistTeachers
    }
  }: RootState = useSelector(selectStore)

  const [workScheduleForm] = Form.useForm()

  const [type, setType] = useState<string>("");
  const [subType, setSubType] = useState<string>("");


  const [modalAddWork, setModalAddWork] = useState<boolean>(false)
  const [modalDeleteSchedule, setModalDeleteSchedule] = useState<boolean>(false)
  const [categoryList, setCategoryList] = useState<any[]>([])
  const [subTabsList, setSubTabsList] = useState<any[]>([])
  const [modalDeleteInfo, setModalDeleteInfo] = useState<any>(null)
  const [needReasonText, setNeedReasonText] = useState<boolean>(false)
  const [worksParams, setWorksParams] = useState<object>({})
  const [workColumns, setWorkColumns] = useState<any>([])

  const actionColumn = [
    {
      title: 'Действие',
      key: 'Действие',
      dataIndex: 'action',
      width: 100,
      render: (item: any, record: any, index: any) => {
        return (
          <Row gutter={6} style={{ width: '100%' }} justify='center'>
            <Col>
              {/* <MyButton icon={<EyeOutlined />} type='text' width={40} height={40} style={{ padding: 0 }}
                onClick={() => {
                  goToView(record.id)
                }} /> */}
              <MyButton icon={<EditOutlined />} type='text' width={40} height={40} style={{ padding: 0 }}
                onClick={() => {
                  setEditWorks(record)
                  setModalAddWork(true);
                }} />
              <MyButton icon={<DeleteOutlined />} type='text' width={40} height={40} style={{ padding: 0 }}
                onClick={() => {
                  setModalDeleteInfo(record.id)
                  setModalDeleteSchedule(true);
                }} />
            </Col>
          </Row>
        )
      }
    }
  ]
  const workParentInd = [FORM.GROUP_ID, FORM.STUDENT, FORM.PARENT, FORM.REASON_TYPE, FORM.PERIODICITY, FORM.THEME, FORM.DATE, FORM.DURATION, FORM.NOTE];
  const workParentGroup = [FORM.GROUP_ID, FORM.THEME, FORM.DATE, FORM.ATTENDEES_COUNT, FORM.NOTE];

  const workStudentInd = [FORM.GROUP_ID, FORM.STUDENT, FORM.REASON_TYPE, FORM.PERIODICITY, FORM.THEME, FORM.DATE, FORM.DURATION, FORM.NOTE];
  const workStudentGroup = [FORM.GROUP_ID, FORM.THEME, FORM.DATE, FORM.ATTENDEES_COUNT, FORM.NOTE];

  const workTeacherInd = [FORM.TEACHER_FORM, FORM.REASON_TYPE, FORM.PERIODICITY, FORM.THEME, FORM.DATE, FORM.DURATION, FORM.NOTE];
  const workTeacherGroup = [FORM.THEME, FORM.DATE, FORM.ATTENDEES_COUNT, FORM.NOTE];





  useEffect(() => {
    setSubType("")
    setType("")
    setTabs();
  }, [selectedType])

  useEffect(() => {
    if (deletePsychologistWorkData.success) {
      setModalDeleteInfo(null);
      setModalDeleteSchedule(false);
      dispatch(getPsychologistWork(worksParams))
    }
  }, [deletePsychologistWorkData])

  useEffect(() => {
    if (psychologistWorkFilter.success) {
      if (typeQuery && typeQuerySubInner && selectedType) {
        setType(typeQuery)
        setSubType(typeQuerySubInner)
        getFormTableColumn(selectedType, type, typeQuerySubInner);

        dispatch(getPsychologistWork(setParams(typeQuery, typeQuerySubInner)))
      }
      const subTabsType = Object.values(psychologistWorkFilter?.data?.type)?.map((item: any) => {
        return {
          key: item,
          label: item,
          children: (
            <Row style={{ margin: 24 }}>
              <Col span={24}>
                <Row justify={'space-between'}>
                  <MyText size={24} weight={700} color='var(--c-title-text)'>
                    {item}
                  </MyText>
                  <Col>
                    <Button style={{ marginLeft: 16 }} onClick={() => { openModalAdd() }}>Добавить</Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          )
        }
      })
      setSubTabsList([...subTabsType])
      setTabs();
    }
  }, [psychologistWorkFilter])

  useEffect(() => {
    if (editPsychologistWork.success || postPsychologistWorkData.success) {
      dispatch(getPsychologistWork(worksParams));
      setModalAddWork(false);
    }
  }, [postPsychologistWorkData, editPsychologistWork])


  // const goToView = (id: any) => {
  //   const path = {
  //     pathname: generatePath(ROUTE_PATH.PSYCHOLOGIST_WORK_VIEW, { id: id }),
  //   }
  //   navigate(path)
  // }

  const setTabs = () => {
    if (Object.values(psychologistWorkFilter?.data).length) {
      const data = Object.values(psychologistWorkFilter?.data?.category)?.map((item: any) => {
        return {
          key: item,
          label: item,
        }
      })
      const teacherData = Object.values(psychologistWorkFilter?.data?.categories_teacher)?.map((item: any) => {
        return {
          key: item,
          label: item,
        }
      })
      switch (selectedType) {
        case WORK_PARENT:
          setCategoryList([...data])
          dispatch(getPsychologistWorkGroup())
          break;
        case WORK_TEACHER:
          setCategoryList([...teacherData])
          dispatch(getPsychologistTeachers())
          break;
        default:
          setCategoryList([...data])
          dispatch(getPsychologistWorkGroup())
          break;
      }
    }
  }

  const openModalAdd = () => {
    setModalAddWork(true)
  }

  const deleteSchedule = () => {
    dispatch(deletePsychologistWork(modalDeleteInfo))
  }

  const setParams = (typeTemp: any, subTypeTemp: any) => {
    if (!Object.values(psychologistWorkFilter?.data).length) return
    const findedCategory = Object.entries(selectedType == WORK_TEACHER ? psychologistWorkFilter.data?.categories_teacher : psychologistWorkFilter.data?.category).find((item: any) => {
      return item[1] == typeTemp;
    });
    const findedSubtype = Object.entries(psychologistWorkFilter.data?.type).find((item: any) => {
      return item[1] == subTypeTemp;
    });

    const findedWorkType = Object.entries(psychologistWorkFilter.data?.work_type).find((item: any) => {
      return item[1] == selectedType;
    });
    const params = {
      work_type: Number(findedWorkType && findedWorkType[0]),
      category: Number(findedCategory && findedCategory[0]),
      type: Number(findedSubtype && findedSubtype[0])
    }

    setWorksParams(params);
    return params;
  }

  const handleClickSubTab = (key: any) => {
    setSearchParams({ [QUERY_PARAMS.type]: searchParams.get(QUERY_PARAMS.type), [QUERY_PARAMS.subtitle]: searchParams.get(QUERY_PARAMS.subtitle), [QUERY_PARAMS.subInner]: key })

    setSubType(key)
    getFormTableColumn(selectedType, type, key);
    dispatch(getPsychologistWork(setParams(type, key)))
  }

  const onCloseModal = () => {
    setModalAddWork(false)
    setNeedReasonText(false)
    workScheduleForm.resetFields();
  }

  const sendNewOrEditWork = (values: any) => {

    let data = {
      ...values,
      [FORM.DATE]: dayjs(values?.date_at).format(DATE_FORMAT.FRONT),
      ...worksParams
    }
    if (selectedType != WORK_TEACHER && values[FORM.STUDENT]) {
      const studentID = psychologistWorkGroupsStudents.data?.students.find((item: any) => {
        return item.student == values[FORM.STUDENT]
      })?.id;
      console.log("studentID", studentID)
      data = {
        ...data,
        [FORM.STUDENT]: studentID ? studentID : values[FORM.STUDENT],
      }
    } else if (selectedType == WORK_TEACHER) {
      const teacherID = Object.entries(psychologistTeachers.data?.employees).find((item: any) => {
        return item[1] == values[FORM.TEACHER]
      })?.[0];
      data = {
        ...data,
        [FORM.TEACHER]: teacherID ? teacherID : values[FORM.TEACHER],
      }
    }
    if (data?.id) {
      dispatch(putPsychologistWork(data))
    } else {
      dispatch(postPsychologistWork(data))
    }

    workScheduleForm.resetFields();
  }

  const handleClickOuterTab = (key: any) => {
    setSearchParams({ [QUERY_PARAMS.type]: searchParams.get(QUERY_PARAMS.type), [QUERY_PARAMS.subtitle]: key })
    setSubType("");
    setType(key)
  }

  const getStudentsByGroup = (item: any) => {
    if (subType !== GROUP) {
      dispatch(getPsychologistWorkGroupStudents(item))
    }
  }

  const setEditWorks = (data: any) => {
    const findedID = psychologistWorkGroups.data && psychologistWorkGroups.data?.groups && Object.entries(psychologistWorkGroups.data?.groups).find((item) => {
      return item[1] == data[FORM.GROUP]
    });
    if (selectedType == WORK_TEACHER) {
      dispatch(getPsychologistTeachers())
      data = { ...data, [FORM.TEACHER]: data.employee }
    } else {
      getStudentsByGroup(findedID && findedID[0])
      data = { ...data, [FORM.STUDENT]: data.student }
    }
    setNeedReasonText(Number(data[FORM.REASON_TYPE]) === 0 ? true : false)
    const calcDuration = Number(data.hours * 60) + Number(data.minutes)
    workScheduleForm.setFieldsValue({
      ...data,
      [FORM.DATE]: dayjs(data[FORM.DATE], DATE_FORMAT.FRONT),
      [FORM.GROUP_ID]: findedID && findedID[0],
      [FORM.PARENT]: String(data[FORM.PARENT]),
      [FORM.PERIODICITY]: String(data[FORM.PERIODICITY]),
      [FORM.REASON_TYPE]: String(data[FORM.REASON_TYPE]),
      [FORM.DURATION]: calcDuration
    });
  }

  const getFormItemByName = (name: string) => {
    switch (name) {
      case FORM.TEACHER_FORM:
        return (
          <ModalBodyItem key={name} label={<ModalBodyItemText>Педагог:</ModalBodyItemText>} name={[FORM.TEACHER]} rules={rules}>
            <Select
              showSearch
              filterOption={(input: any, option: any) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              disabled={workScheduleForm.getFieldValue(FORM.ID)}
              style={{ width: "100%" }}
              placeholder='Педагог'>
              {
                psychologistTeachers.data && psychologistTeachers.data?.employees && Object.entries(psychologistTeachers.data?.employees)?.map((item: any) => (
                  <Select.Option key={item[0]} value={item[0]}>
                    {item[1]}
                  </Select.Option>
                ))
              }
            </Select>
          </ModalBodyItem>
        )
      case FORM.GROUP_ID:
        return (
          <ModalBodyItem key={name} label={<ModalBodyItemText>Группа:</ModalBodyItemText>} name={[FORM.GROUP_ID]} rules={rules}>
            <Select
              disabled={workScheduleForm.getFieldValue(FORM.ID)}
              onChange={(item) => getStudentsByGroup(item)}
              showSearch
              filterOption={(input: any, option: any) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              style={{ width: "100%" }}
              placeholder='Группа'>
              {
                psychologistWorkGroups.data && psychologistWorkGroups.data?.groups && Object.entries(psychologistWorkGroups.data?.groups)?.map((item: any) => (
                  <Select.Option key={item[0]} value={item[0]}>
                    {item[1]}
                  </Select.Option>
                ))
              }
            </Select>
          </ModalBodyItem>
        )
      case FORM.THEME:
        return (
          <ModalBodyItem key={name} label={<ModalBodyItemText>Тема:</ModalBodyItemText>} name={[FORM.THEME]} rules={rules}>
            <TextArea rows={4}></TextArea>
          </ModalBodyItem>
        )
      case FORM.DATE:
        return (
          <ModalBodyItem key={name} label={<ModalBodyItemText>Дата:</ModalBodyItemText>} name={[FORM.DATE]} rules={rules}>
            <DatePicker locale={locale} placeholder="Дата" format={DATE_FORMAT.FRONT} style={{ width: "100%" }} />
          </ModalBodyItem>
        )
      case FORM.ATTENDEES_COUNT:
        return (
          <ModalBodyItem key={name} label={<ModalBodyItemText>Количество присутствующих :</ModalBodyItemText>} name={[FORM.ATTENDEES_COUNT]} rules={rules}>
            <InputNumber addonAfter={'чел'}></InputNumber>
          </ModalBodyItem>
        )
      case FORM.STUDENT:
        return (
          <ModalBodyItem key={name} label={<ModalBodyItemText>Студент:</ModalBodyItemText>} name={[FORM.STUDENT]} rules={rules}>
            <Select
              showSearch
              filterOption={(input: any, option: any) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              disabled={workScheduleForm.getFieldValue(FORM.ID)}
              style={{ width: "100%" }}
              placeholder='Студент'>
              {
                psychologistWorkGroupsStudents.data?.students?.map((item: any) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.student}
                  </Select.Option>
                ))
              }
            </Select>
          </ModalBodyItem>
        )
      case FORM.PARENT:
        return (
          <ModalBodyItem key={name} label={<ModalBodyItemText>Родитель:</ModalBodyItemText>} name={[FORM.PARENT]} rules={rules}>
            <Select
              style={{ width: "100%" }}
              placeholder='Родитель'>
              {
                Object.entries(psychologistWorkFilter.data?.parent_type).map((item: any) => (
                  <Select.Option key={item[0]} value={item[0]}>
                    {item[1]}
                  </Select.Option>
                ))
              }
            </Select>
          </ModalBodyItem>
        )
      case FORM.REASON_TYPE:
        const typeOfConsult = WORK_TEACHER == selectedType ? psychologistWorkFilter.data?.reasons_teacher : psychologistWorkFilter.data?.reason_type
        return (
          <>
            <ModalBodyItem key={name} label={<ModalBodyItemText>Причина консультации:</ModalBodyItemText>} name={[FORM.REASON_TYPE]} rules={rules}>
              <Select
                onChange={(item) => setNeedReasonText(item == 0 ? true : false)}
                style={{ width: "100%" }}
                placeholder='Причина консультации'>
                {
                  Object.entries(typeOfConsult).map((item: any) => (
                    <Select.Option key={item[0]} value={item[0]}>
                      {item[1]}
                    </Select.Option>
                  ))
                }
              </Select>
            </ModalBodyItem>
            {
              needReasonText ?
                <ModalBodyItem key={name + FORM.REASON_TEXT} label={<ModalBodyItemText>Причина консультации:</ModalBodyItemText>} name={[FORM.REASON_TEXT]} rules={rules}>
                  <TextArea rows={4}></TextArea>
                </ModalBodyItem> : null
            }
          </>
        )
      case FORM.PERIODICITY:
        return (
          <ModalBodyItem key={name} label={<ModalBodyItemText>Периодичность:</ModalBodyItemText>} name={[FORM.PERIODICITY]} rules={rules}>
            <Select
              style={{ width: "100%" }}
              placeholder='Периодичность'>
              {
                Object.entries(psychologistWorkFilter.data?.periodicity)?.map((item: any) => (
                  <Select.Option key={item[0]} value={item[0]}>
                    {item[1]}
                  </Select.Option>
                ))
              }
            </Select>
          </ModalBodyItem>
        )
      case FORM.DURATION:
        return (
          <ModalBodyItem key={name} label={<ModalBodyItemText>Продолжительность :</ModalBodyItemText>} name={[FORM.DURATION]} rules={rules}>
            <InputNumber addonAfter={'мин'}></InputNumber>
          </ModalBodyItem>
        )
      case FORM.NOTE:
        return (
          <ModalBodyItem key={name} label={<ModalBodyItemText>Примечания :</ModalBodyItemText>} name={[FORM.NOTE]} rules={rules}>
            <TextArea rows={4}></TextArea>
          </ModalBodyItem>
        )
    }
  }
  const getFormByType = (selectedTypeForm: any, typeForm: any, typeSubForm: any) => {

    let answer = [];
    switch (selectedTypeForm) {
      case WORK_PARENT:
        answer = typeSubForm == GROUP ? workParentGroup : workParentInd;
        return answer.map((item: string) => getFormItemByName(item));
      case WORK_TEACHER:
        answer = typeSubForm == GROUP ? workTeacherGroup : workTeacherInd;
        return answer.map((item: string) => getFormItemByName(item))
      default:
        answer = typeSubForm == GROUP ? workStudentGroup : workStudentInd;
        return answer.map((item: string) => getFormItemByName(item))
    }
  }

  const getFormColumnItem = (name: string) => {
    switch (name) {
      case FORM.TEACHER_FORM:
        return {
          title: 'Преподаватель',
          key: 'Преподаватель',
          dataIndex: 'employee',
          width: 150
        }
      case FORM.GROUP_ID:
        return {
          title: 'Группа',
          key: 'Группа',
          dataIndex: 'group',
          width: 200,
          sorter: (a: any, b: any) => {
            if (a.group < b.group) {
              return -1;
            }
            if (a.group > b.group) {
              return 1;
            }
            return 0;
          }
        }
      case FORM.THEME:
        return {
          title: 'Тема',
          key: 'Тема',
          dataIndex: 'theme',
          width: 200,
          render: (item: any, record: any, index: any) => {
            return (<Row><span style={{ maxWidth: 200 , textOverflow:'ellipsis' , whiteSpace:'nowrap' , overflow:'hidden' }}>{record.theme}</span></Row>)
          },
        }
      case FORM.DATE:
        return {
          title: 'Дата',
          key: 'Дата',
          dataIndex: 'date_at',
          width: 100,
          sorter: (a: any, b: any) => {
            if (dayjs(a.date_at).isBefore(b.date_at)) {
              return -1;
            }
            if (dayjs(a.date_at).isAfter(b.date_at)) {
              return 1;
            }
            return 0;
          }
        }
      case FORM.ATTENDEES_COUNT:
        return {
          title: 'Количество присутствующих',
          key: 'Количество присутствующих',
          dataIndex: 'attendees_count',
          width: 150,
        }
      case FORM.STUDENT:
        return {
          title: 'Студент',
          key: 'Студент',
          dataIndex: 'student',
          // ellipsis: true
        }
      case FORM.PARENT:
        return {
          title: 'Родитель',
          key: 'Родитель',
          dataIndex: 'parent_type_text',
          width: 80
        }
      case FORM.REASON_TYPE:
        return {
          title: 'Причина консультации',
          key: 'Причина консультации',
          dataIndex: 'reason_type_text',
          width: 150
        }
      case FORM.PERIODICITY:
        return {
          title: 'Периодичность',
          key: 'Периодичность',
          dataIndex: 'periodicity_name',
          width: 100,
        }
      case FORM.DURATION:
        return {
          title: 'Продолжительность',
          key: 'Продолжительность',
          dataIndex: 'duration',
          width: 70,
          render: (item: any, record: any, index: any) => {
            return (
              Number(Number(record?.hours) * 60) + Number(record?.minutes)
            )
          },
        }
      case FORM.NOTE:
        return {
          title: 'Примечание',
          key: 'Примечание',
          dataIndex: 'note',
          ellipsis: true,
          width: 200,
          render: (item: any, record: any, index: any) => {
            return (<Row><span style={{ maxWidth: 200 , textOverflow:'ellipsis' , whiteSpace:'nowrap' , overflow:'hidden' }}>{record.note}</span></Row>)
          },
        }
    }
  }
  const getFormTableColumn = (selectedTypeForm: any, typeForm: any, typeSubForm: any) => {
    let answer = [];
    switch (selectedTypeForm) {
      case WORK_PARENT:
        answer = typeSubForm == GROUP ? workParentGroup : workParentInd;
        break;
      case WORK_TEACHER:
        answer = typeSubForm == GROUP ? workTeacherGroup : workTeacherInd;
        break;
      default:
        answer = typeSubForm == GROUP ? workStudentGroup : workStudentInd;
        break;
    }

    setWorkColumns([...answer.map((item: string) => getFormColumnItem(item))])
  }

  return (
    <>
      <InnerTabs items={categoryList} onChange={(key) => handleClickOuterTab(key)} activeKey={type} />
      {(type != '' && type != 'questionnaire') && <InnerTabs items={subTabsList} onChange={(key) => handleClickSubTab(key)} activeKey={subType} />}
      {
        subType && <Col style={{ width: '100%' }}>
          <Table style={{ width: '100%' }} scroll={{
            x: 'max-content',
          }} locale={{
            triggerDesc: t("triggerDesc"),
            triggerAsc: t("triggerAsc"),
            cancelSort: t("cancelSort"),
            emptyText: () =>
              <Row style={{ padding: 32 }} justify={'center'}>
                {
                  "Ничего не найдено"
                }
              </Row>
          }} columns={[...workColumns, ...actionColumn]}
            dataSource={psychologistWork?.data} loading={psychologistWork.loading}
            rowKey={(item) => item.id} pagination={false} />
        </Col>
      }

      <Modal footer={null} onCancel={() => { onCloseModal() }} open={modalAddWork}>
        <Row style={{ marginBottom: 12 }}>
          <ModalTitle>Добавления {subType}</ModalTitle>
        </Row>
        {psychologistWorkFilter && psychologistWorkFilter?.data && Object.values(psychologistWorkFilter?.data).length && <Form onFinish={(values) => sendNewOrEditWork(values)}
          onReset={() => { onCloseModal() }}
          form={workScheduleForm} layout={"vertical"} >
          <ModalBodyItem style={{ display: 'none' }} name={[FORM.ID]} >
            <Input></Input>
          </ModalBodyItem>
          {
            getFormByType(selectedType, type, subType)
          }
          <Form.Item >
            <Row justify={'end'}>
              <Button type="default" htmlType="reset">
                Отмена
              </Button>
              <Button style={{ marginLeft: 16 }} type="primary" htmlType="submit">
                {
                  workScheduleForm.getFieldValue(FORM.ID) ? "Сохранить" : "Добавить"
                }
              </Button>
            </Row>
          </Form.Item>
        </Form>
        }

      </Modal>

      <Modal open={modalDeleteSchedule} onCancel={() => setModalDeleteSchedule(false)} okText="Удалить" cancelText="Отмена" onOk={() => { deleteSchedule() }}>
        <Row style={{ marginBottom: 12 }}>
          <ModalTitle>Удалить расписание №{modalDeleteInfo}</ModalTitle>
        </Row>
      </Modal>
    </>
  )
}
